module.exports = __webpack_public_path__ + "img/imgdunaa.618a6175.png";